import { useTranslation } from 'react-i18next';

type Props = {
  translationKey: string;
};

export const NetworkSpeedTranslation = ({ translationKey }: Props) => {
  const { t } = useTranslation();

  switch (translationKey) {
    case 'networkspeed.network_3g':
      return t('networkspeed.network_3g', '3G');
    case 'networkspeed.network_4g':
      return t('networkspeed.network_4g', '4G');
    case 'networkspeed.network_5g':
      return t('networkspeed.network_5g', '5G');
    case 'networkspeed.network_4g_5g':
      return t('networkspeed.network_4g_5g', '4G / 5G');
    default:
      return '';
  }
};
